<!--
 * @Author: gaoxueting
 * @Date: 2020-06-22 20:08:14
 * @LastEditTime: 2020-08-03 18:12:15
 * @LastEditors: fengzhongmei
 * @Description:
-->
<template>
    <Modal v-model="modal"
           :mask-closable="false"
           :title="$t('绑定的服务器')"
           @on-cancel="cancel"
           width="720"
           class="bindserver">
        <rcTable ref="rcTable"
                 :tableAttr="tableAttr"
                 @onSelectChange="onSelectChange"></rcTable>
        <div slot="footer">
            <Button @click="cancel"
                    class="ivu-btn-text">{{
                $t("取消")
            }}</Button>
            <Button type="primary"
                    @click="save"
                    :loading="loading">
                <span v-show="!loading">&nbsp;{{ $t("确认") }}&nbsp;</span>
                <span v-show="loading">&nbsp;{{ $t("确认中") }}&nbsp;</span>
            </Button>
        </div>
    </Modal>
</template>

<script>
import API from '@/service/api.js'
import rcTable from '@c/basic/rcTable'
// import { getOne } from '@/service/utils.js'
export default {
    name: 'createvirip',
    props: [],
    components: {
        rcTable
    },
    data () {
        return {
            modal: false,
            loading: false,
            id: this.$route.params.id,
            envId: this.$route.query.envId,
            choosed: null,
            rowData: null,
            tableAttr: {
                hideHead: true,
                source: {
                    type: 'staticData',
                    tableData: {
                        totalRows: 0,
                        dataList: []
                    }
                },
                columns: [
                    {
                        key: 'instanceName',
                        title: this.$i18n.t('名称'),
                        className: 'rc-ellipsis',
                        render: (h, params) => {
                            return h('span', params.row.instanceName)
                        }
                    },
                    {
                        title: this.$t('类型'),
                        render: (h, params) => {
                            return h('div', [
                                h('p', params.row.serverType === 'instance' ? '实例' : '')
                            ])
                        }
                    },
                    {
                        title: this.$t('状态'),
                        render: (h, params) => {
                            return h('statusview', {
                                props: {
                                    state: params.row.status.toLowerCase(),
                                    stateName: this.$i18n.t(params.row.statusName)
                                }
                            })
                        }
                    },
                    {
                        key: 'portIp',
                        title: this.$i18n.t('私有IP地址'),
                        className: 'rc-ellipsis'
                    },
                    {
                        title: this.$i18n.t('操作'),
                        render: (h, params) => {
                            return h('div', {
                                class: 'tbl-btn-div'
                            }, [
                                h('a', { on: { click: () => this.delete(params.row) } }, this.$i18n.t('解绑'))
                            ])
                        }
                    }
                ]
            },
            statusList: {
                ACTIVE: '已绑定',
                UNUSED: '未绑定'
            }
        }
    },
    created () {

    },
    methods: {
        onSelectChange (rows) {
            this.choosed = rows
        },
        // 打开弹出框
        openModal (row) {
            this.modal = true
            this.rowData = row
            this.axios.get(this.urlFormat(API.PORTS_BIND_SERVER, false), {
                params: {
                    cloudEnvId: this.$route.query.envId,
                    portId: row.id
                }
            }).then(res => {
                this.tableAttr.source.tableData.totalRows = res.length
                this.tableAttr.source.tableData.dataList = res
                this.$refs.rcTable && this.$refs.rcTable.init()
                this.choosed = this.tableAttr.source.tableData.dataList[0]
            })
        },
        // 取消
        cancel () {
            this.modal = false
        },
        delete (row) {
            this.$rcNewModal({
                message: `您确定要解绑该[${row.instanceName}]云主机吗？`,
                callback: () => {
                    this.axios.post(this.urlFormat(API.POST_DETACH_SERVER, false), {
                        portId: this.rowData.id,
                        vmId: row.id,
                        vmPortId: row.vmPortId
                    }).then(res => {
                        this.cancel()
                        this.$emit('refresh')
                    })
                }
            })
        },
        // 表单提交
        save () {
            const params = {
                portId: this.rowData.id,
                floatingIpId: this.choosed.id
            }
            this.axios
                .post(this.urlFormat(API.POST_ATTACH_FLOATIP, false), params)
                .then(res => {
                    if (res.status) {
                        this.cancel()
                        this.$emit('refresh')
                    }
                    this.loading = false
                })
                .catch(e => {
                    this.loading = false
                })
        }
    }
}
</script>
<style lang="less">
.bindserver {
    .ivu-modal-body {
        max-height: 450px;
        overflow: hidden;
        overflow-y: auto;
        padding-left: 20px;
    }
}
</style>
